import React from 'react';

function OtherSkills() {
    return (
            <div className="otherSkills">
                <h3>
                    Autre compétences
                </h3>
                <div className="list">
                    <ul>
                        <li>
                            <i className="fa fa-check-circle">Anglais</i>
                        </li>
                        <li>
                            <i className="fa fa-check-circle">Français</i>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <i className="fa fa-check-circle">Force de proposition</i>
                        </li>
                        <li>
                            <i className="fa fa-check-circle">autonomie</i>
                        </li>
                        <li>
                            <i className="fa fa-check-circle">adaptation</i>
                        </li>
                    </ul>
                </div>
            </div>
    );
}

export default OtherSkills;
